var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseRounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m9.15 8 4.61-4.61c.15-.15.24-.36.24-.58s-.09-.43-.24-.58a.827.827 0 0 0-1.15 0L8 6.84l-4.61-4.6c-.31-.31-.84-.31-1.15 0s-.31.84 0 1.15L6.85 8l-4.61 4.61c-.31.31-.31.84 0 1.15s.84.31 1.15 0L8 9.15l4.61 4.61c.16.16.37.23.58.23s.42-.08.57-.23.24-.36.24-.58-.09-.43-.24-.58L9.15 7.99Z"
})));
export default SvgCloseRounded;